const version = "0.1.0";

const solarSystemConfig = {
  height: 472,
  planets: [
    {
      name: "Sun",
      nickname: "Sol",
      type: "Yellow Dwarf",
      lengthOfYear: "230 million Earth years",
      distanceFromSun: "N/A",
      moons: "N/A",
      description:
        "The Sun is a yellow dwarf star, a hot ball of glowing gases at the heart of our solar system. Its gravity holds everything from the biggest planets to tiny debris in its orbit.",
      x: 0,
      size: 35,
      colour: "#d98b21",
      hasRing: false,
    },
    {
      name: "Mercury",
      nickname: "The Swift Planet",
      type: "Terrestrial",
      lengthOfYear: "88 Earth Days",
      distanceFromSun: "69,711,928 km",
      moons: "0",
      description:
        "Mercury—the smallest planet in our solar system and closest to the Sun—is only slightly larger than Earth's Moon. Mercury is the fastest planet, zipping around the Sun every 88 Earth days.",
      x: 86,
      size: 11,
      colour: "#a5a5a5",
      hasRing: false,
    },
    {
      name: "Venus",
      nickname: "The Evening Star",
      type: "Terrestrial",
      lengthOfYear: "225 Earth Days",
      distanceFromSun: "108,052,238 km",
      moons: "0",
      description:
        "Venus spins slowly in the opposite direction from most planets. A thick atmosphere traps heat in a runaway greenhouse effect, making it the hottest planet in our solar system.",
      x: 136,
      size: 23,
      colour: "#cc8642",
      hasRing: false,
    },
    {
      name: "Earth",
      nickname: "The Blue Planet",
      type: "Terrestrial",
      lengthOfYear: "365.25 Earth Days",
      distanceFromSun: "147,407,403 km",
      moons: "1",
      description:
        "Earth — our home planet — is the only place we know of so far that’s inhabited by living things. It's also the only planet in our solar system with liquid water on the surface.",
      x: 192,
      size: 25,
      colour: "#276fdd",
      hasRing: false,
    },
    {
      name: "Mars",
      nickname: "The Red Planet",
      type: "Terrestrial",
      lengthOfYear: "1.88 Earth Years",
      distanceFromSun: "234,693,978 km",
      moons: "2",
      description:
        "Mars is a dusty, cold, desert world with a very thin atmosphere. There is strong evidence Mars was—billions of years ago—wetter and warmer, with a thicker atmosphere.",
      x: 229,
      size: 17,
      colour: "#cb3535",
      hasRing: false,
    },
    {
      name: "Jupiter",
      nickname: "The Gas Giant",
      type: "Gas Giant",
      lengthOfYear: "11.86 Earth Years",
      distanceFromSun: "747,738,353 km",
      moons: "79",
      description:
        "Jupiter is more than twice as massive than the other planets of our solar system combined. The giant planet's Great Red spot is a centuries-old storm bigger than Earth.",
      x: 322,
      size: 35,
      colour: "#b57e66",
      hasRing: false,
    },
    {
      name: "Saturn",
      nickname: "The Ringed Planet",
      type: "Gas Giant",
      lengthOfYear: "29.4 Earth Years",
      distanceFromSun: "1,484,788,109 km",
      moons: "62",
      description:
        "Adorned with a dazzling, complex system of icy rings, Saturn is unique in our solar system. The other giant planets have rings, but none are as spectacular as Saturn's.",
      x: 385,
      size: 25,
      colour: "#d4ad31",
      hasRing: true,
    },
    {
      name: "Uranus",
      nickname: "The Bulls-eye Planet",
      type: "Ice Giant",
      lengthOfYear: "84 Earth Years",
      distanceFromSun: "2,915,980,712 km",
      moons: "27",
      description:
        "Uranus—seventh planet from the Sun—rotates at a nearly 90-degree angle from the plane of its orbit. This unique tilt makes Uranus appear to spin on its side.",
      x: 440,
      size: 17,
      colour: "#4c99ce",
      hasRing: false,
    },
    {
      name: "Neptune",
      nickname: "The planet exterior to Uranus",
      type: "Ice Giant",
      lengthOfYear: "164.81 Earth Years",
      distanceFromSun: "4,476,082,673 km",
      moons: "14",
      description:
        "Neptune—the eighth and most distant major planet orbiting our Sun—is dark, cold and whipped by supersonic winds. It was the first planet located through mathematical calculations, rather than by telescope.",
      x: 472,
      size: 17,
      colour: "#3163f3",
      hasRing: false,
    },
  ],
};

export { version, solarSystemConfig };

// "The Sun" (https://skfb.ly/IRWo) by kongle is licensed under Creative Commons Attribution-ShareAlike (http://creativecommons.org/licenses/by-sa/4.0/).
// "Mercury" (https://skfb.ly/6TwFJ) by Akshat is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Venus" (https://skfb.ly/ITvT) by kongle is licensed under Creative Commons Attribution-ShareAlike (http://creativecommons.org/licenses/by-sa/4.0/).
// "Tierra v1.1" (https://skfb.ly/LqtV) by uperesito is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Marte v1.1" (https://skfb.ly/6Dsuy) by uperesito is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Júpiter v1.1" (https://skfb.ly/6Dsw7) by uperesito is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Saturno v1.1" (https://skfb.ly/6DvsG) by uperesito is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Urano" (https://skfb.ly/QzrT) by uperesito is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
// "Neptune" (https://skfb.ly/6TwJ9) by Akshat is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
